import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const KanbanAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/kanban",
      method: "GET",
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  calculateCtr: async function (data, cancel = false) {
    const response = await api.request({
      url: "/kanban/calculate-ctr",
      method: "POST",
      data: data,
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  checkDataForCtr: async function (cancel = false) {
    const response = await api.request({
      url: "/kanban/check-data-ctr",
      method: "GET",
      signal: cancel ? cancelApiObject[this.checkDataForCtr.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  order: async function (cancel = false) {
    const response = await api.request({
      url: "/order",
      method: "GET",
      signal: cancel ? cancelApiObject[this.order.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  getCtrProgress: async function (cancel = false) {
    const response = await api.request({
      url: "/ctr/progress",
      method: "GET",
      signal: cancel ? cancelApiObject[this.getCtrProgress.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(KanbanAPI)